import { Routes } from '@angular/router'
import { CelebrateComponent } from './containers/celebrate/celebrate.component'
import { NeedloginGuard } from './guards/needlogin.guard'
import { ConfigurationIdResolver } from './resolvers/configurationId.resolver'
import { OptionsComponent } from './containers/options/options.component'
import { LayoutComponent } from './containers/layout/layout.component'
import { ConfirmComponent } from './containers/confirm/confirm.component'
import { BasePathResolver } from '../../../../framework/module-base-path/basePath.resolver'
import { StepDatalayerGuard } from './guards/step-datalayer.guard'
import { RouteWildcardResolver } from 'framework/route-wildcard-resolver/route-wildcard.resolver'

export const configuratorFactoryRoutes: Routes = [
    {
        path: 'configurator',
        pathMatch: 'prefix',
        redirectTo: '',
    },
    {
        path: '',
        resolve: {
            configurationId: ConfigurationIdResolver,
            basePath: BasePathResolver,
        },
        children: [
            {
                path: '',
                component: LayoutComponent,
                children: [
                    {
                        path: '',
                        component: OptionsComponent,
                        data: {
                            skipLogin: true,
                        },
                        canActivate: [NeedloginGuard, StepDatalayerGuard],
                    },
                    {
                        path: 'contract',
                        component: OptionsComponent,
                        canActivate: [NeedloginGuard, StepDatalayerGuard],
                    },
                    {
                        path: 'calibrate',
                        component: OptionsComponent,
                        canActivate: [NeedloginGuard, StepDatalayerGuard],
                    },
                    {
                        path: 'confirm',
                        component: ConfirmComponent,
                        canActivate: [NeedloginGuard, StepDatalayerGuard],
                    },
                ],
            },
            {
                path: 'celebrate',
                component: CelebrateComponent,
                canActivate: [NeedloginGuard],
            },
            {
                // deprecated
                path: 'almost-there',
                component: CelebrateComponent,
                canActivate: [NeedloginGuard],
            },
            {
                // deprecated
                path: 'checkup',
                component: OptionsComponent,
                canActivate: [NeedloginGuard, StepDatalayerGuard],
            },
            // Fallback rule for if APP_BASE_HREF setting is causing issues.
            {
                path: '**',
                resolve: {
                    resolveAppBaseHref: RouteWildcardResolver,
                },
            },
        ],
    },
]
